import { sha256 } from 'js-sha256';

/**
 * Hashes a password the same way the ng-app login does:
 * sha256 of the plain text → base64 of the binary digest.
 *
 * The ums-server expects exactly this format and re-hashes it with
 * bcrypt against the stored hash.
 *
 * Uses js-sha256 (pure-js) rather than crypto.subtle so the app keeps
 * working on non-secure dev contexts (e.g. http://bh-dev.mymedax.lan).
 */
export async function hashPassword(password: string): Promise<string> {
  const digest = sha256.arrayBuffer(password);
  return bytesToBase64(new Uint8Array(digest));
}

function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, Math.min(i + chunkSize, bytes.length));
    binary += String.fromCharCode.apply(null, Array.from(chunk));
  }
  return btoa(binary);
}
